import { Component } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';
@Component({
  selector: 'app-material-tooltip',
  standalone: false,
  templateUrl: './material-tooltip.component.html',
  styleUrls: ['./material-tooltip.component.scss'],
})
export class MaterialTooltipComponent implements ITooltipAngularComp {
  tooltipText: string | null = '';

  agInit(params: ITooltipParams): void {
    const doc = new DOMParser().parseFromString(params.value, 'text/html');
    this.tooltipText = doc.documentElement.textContent;
  }
}
